import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import Event from '../../interfaces/Event.interface';

const selectEvents = (state: RootState) => state.events;

export const selectAllEvents = () => createSelector(
  [selectEvents],
  (events) => {
    return events.events;
  }
);

export const selectEventById = (id: number) => createSelector(
  [selectEvents],
  (events) => {
    return events.events.find((event: Event) => event.id === id)
  }
);

export const selectEventsByParentId = (parentId: number) => createSelector(
  [selectEvents],
  (events) => {
    return events.events.filter((event: Event) => event.parentTaskId === parentId);
  }
);

export const selectUncompleteEventsByParentId = (parentTaskId: number | null) => createSelector(
  [selectEvents],
  (events) => {
    return events.events.filter((event: Event) => {
      return event.parentTaskId === parentTaskId && event.completed === false;
    })
  }
);

export const selectUncompleteEvents = () => createSelector(
  [selectEvents],
  (events) => {
    return events.events.filter((event: Event) => {
      return event.completed === false;
    })
  }
);

export const selectCompleteEventsByParentId = (parentTaskId: number | null) => createSelector(
  [selectEvents],
  (events) => {
    return events.events.filter((event: Event) => {
      return event.parentTaskId === parentTaskId && event.completed === true;
    })
  }
);

export const selectCompleteEvents = () => createSelector(
  [selectEvents],
  (events) => {
    return events.events.filter((event: Event) => {
      return event.completed === true;
    })
  }
);